export default __webpack_public_path__ + "static/timberline-l-series-28-disk-19g-19g-tanks-7e7a2a662f89fe1f4aae1408f0c7ce0e.jpg";